module.exports = __webpack_public_path__ + "static/media/DiningPref.15c0f2af.png";